import { render } from "./TableCountryCodes.vue?vue&type=template&id=139329b8&scoped=true"
import script from "./TableCountryCodes.vue?vue&type=script&lang=js"
export * from "./TableCountryCodes.vue?vue&type=script&lang=js"

import "./TableCountryCodes.vue?vue&type=style&index=0&id=139329b8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-139329b8"]])

export default __exports__